import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/feature/Sidebar";
import TopHeader from "@/components/feature/TopHeader";

const PAGE_TITLES: Record<string, string> = {
  "/": "نظرة عامة",
  "/store": "بيانات المحل",
  "/menu": "إدارة المنيو الرئيسي",
  "/branches": "إدارة الفروع",
  "/employees": "الموظفون والصلاحيات",
  "/orders": "الطلبات والتدخل",
  "/pos": "نقطة البيع (كاشير)",
  "/invoices": "الفواتير الضريبية (ZATCA)",
  "/reports": "التقارير والمبيعات",
  "/financial": "المعاملات المالية والتسويات",
  "/notifications": "الإشعارات",
  "/settings": "إعدادات الحساب",
};

export default function DashboardLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const title =
    PAGE_TITLES[location.pathname] ??
    (location.pathname.startsWith("/orders/") ? "تفاصيل الطلب" : "لوحة التحكم");

  // أغلق الدرج تلقائيًا عند التنقل بين الصفحات
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // امنع تمرير الخلفية أثناء فتح الدرج على الجوال
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarOpen]);

  return (
    <div className="flex min-h-screen bg-background-50">
      {/* القائمة الجانبية — نسخة سطح المكتب (ثابتة) */}
      <div className="hidden lg:block shrink-0 sticky top-0 h-screen w-[260px]">
        <Sidebar />
      </div>

      {/* القائمة الجانبية — نسخة الجوال (درج منزلق) */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-foreground-950/50 yc-fade-in"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          ></div>
          <div className="absolute inset-y-0 start-0 w-[280px] max-w-[85vw] yc-drawer-slide shadow-2xl">
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        <TopHeader title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
          <div className="max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}